(() => {
  if (window.collectionRichAnchorNavigationInitialized) return;
  window.collectionRichAnchorNavigationInitialized = true;

  const root = document.documentElement;
  const header = document.getElementById('SiteHeader');
  const jumpNavigation = document.querySelector('.collection-rich-jump');

  const updateAnchorOffset = () => {
    const headerHeight = header ? header.getBoundingClientRect().height : 0;

    if (headerHeight > 0) {
      root.style.setProperty('--collection-rich-anchor-offset', `${Math.ceil(headerHeight)}px`);
    }
  };

  const getCurrentCollectionAnchor = () => {
    if (!window.location.hash.startsWith('#collection-rich-')) return null;

    try {
      return document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    } catch (error) {
      return null;
    }
  };

  let alignmentFrame;
  const scheduleCurrentCollectionAnchorAlignment = () => {
    if (alignmentFrame) cancelAnimationFrame(alignmentFrame);

    let framesRemaining = 24;
    const stabilizeAlignment = () => {
      updateAnchorOffset();
      const target = getCurrentCollectionAnchor();

      if (!target) {
        alignmentFrame = null;
        return;
      }

      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const difference = target.getBoundingClientRect().top - headerHeight;

      if (Math.abs(difference) > 1) window.scrollBy(0, difference);

      framesRemaining -= 1;
      alignmentFrame = framesRemaining > 0 ? requestAnimationFrame(stabilizeAlignment) : null;
    };

    alignmentFrame = requestAnimationFrame(stabilizeAlignment);
  };

  updateAnchorOffset();
  scheduleCurrentCollectionAnchorAlignment();

  window.addEventListener('resize', updateAnchorOffset, { passive: true });
  window.addEventListener('hashchange', scheduleCurrentCollectionAnchorAlignment);

  if (jumpNavigation) {
    jumpNavigation.addEventListener('focusin', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (link) link.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  if ('ResizeObserver' in window && header) {
    new ResizeObserver(updateAnchorOffset).observe(header);
  }
})();
